import { Button, Col, Form, Input, Modal, Row, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useDispatch, useSelector } from "react-redux";
import { editVideo, toggleModal } from "../../../features/videos/videosSlice";
import { useEffect } from "react";
import { useAddVideoMutation, useEditVideoMutation } from "../../../features/videos/videosApi";

export default function VideoForm({ }) {
  const dispatch = useDispatch()
  const [form] = Form.useForm();

  const { openModal, video } = useSelector(state => state.videos)
  const [addVideo, { isLoading, isError, error, data }] = useAddVideoMutation();
  const [updateVideo, { isLoading: isUpdating, isError: updateIsError, error: updateError, data: updatedVideo }] = useEditVideoMutation();

  const submitHandler = (data) => {
    try {
      if (video && video?.id) {
        //update video
        updateVideo({ id: video?.id, data })
      } else {
        //add new video
        const createdAt = new Date().toISOString()
        addVideo({ ...data, createdAt })
      }
      cancelHandler()

    } catch (error) {

    }
  }

  const cancelHandler = () => {
    dispatch(toggleModal(false))
    form.resetFields()
    dispatch(editVideo({}))
  }

  useEffect(() => {
    if (video && Object.entries(video).length) {
      form.setFieldsValue({ ...video })
    } else {
      form.resetFields()
    }
  }, [video, form])

  const title = video && video?.id ? 'Update Video' : 'Add New Video';
  
  return (
    <>
      <Modal open={openModal} title={title}
        centered
        footer={false}
        onCancel={cancelHandler}>
        <Form onFinish={submitHandler} form={form} layout="vertical">
          <Form.Item label="Title" name="title" rules={[{ required: true, message: 'Title is required!' }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Description" name="description" rules={[{ required: true, message: 'Description is required!' }]}>
            <TextArea />
          </Form.Item>
          <Form.Item tooltip="insert the embed link" label="youtube video url" name="url" rules={[{ required: true, message: 'Url is required!' }]}>
            <Input placeholder="https://www.youtube.com/embed/E9_R88eKcBM" />
          </Form.Item>
          <Row >
            <Col span={12} className="pr-1">
              <Form.Item label="Views" name="views" rules={[{ required: true, message: 'Views is required!' }]}>
                <Input placeholder="10k / 10M / 100" />
              </Form.Item>
            </Col>
            <Col span={12} className="pl-1">
              <Form.Item labelCol={12} label="Duration" name="duration" rules={[{ required: true, message: 'Duration is required!' }]}>
                <Input placeholder="10:30" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item className="flex justify-end">
            <Space>
              <Button onClick={cancelHandler}>Cancel</Button>
              <Button type="primary" htmlType="submit">Submit</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}